<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<Upload :label="$t('fields.upload')" v-model="uploadedFile"></Upload>
			</v-col>
			<v-col cols="12">
				<v-radio-group row dense class="mt-1" v-model="uploadedFileType" :label="'Tip importa'">
					<v-radio label="Članovi" :value="1"></v-radio>
					<v-radio label="Odjeli/Ogranci" :value="2"></v-radio>
					<v-radio label="Uplate" :value="3"></v-radio>
					<v-radio label="Zanimanja" :value="4"></v-radio>
				</v-radio-group>
			</v-col>
			<v-col cols="2">
				<v-btn style="width: 100%" :disabled="uploadedFile == null" color="primary" @click="importclick"
					>Započni uvoz</v-btn
				>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Upload from '../../trinkets/Upload';

export default {
	name: 'Import',
	components: { Upload },
	data: function () {
		return {
			uploadedFile: null,
			uploadedFileType: 1,
		};
	},
	methods: {
		importclick() {
			let vm = this;
			this.$APICall(
				'post',
				'import-data',
				{ uploadedFileType: this.uploadedFileType, uploadedFile: this.uploadedFile },
				(data, success) => {
					if (success) {
						vm.$notify('Uvoz uspješno obavljen');
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				}
			);
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		} else {
			if (this.$myStore.state.user.email === 'dev@ide3.hr') {
				this.$myStore.commit('setBreadcrumbs', [
					{ text: this.$t('modules.codebooks'), href: '/#/codebooks', disabled: true },
				]);
			} else {
				this.$router.replace('members');
			}
		}
	},
};
</script>

<style scoped></style>
